export default "__VITE_ASSET__cf60620a__"